import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { FormFieldBase } from './form-field-base';

@Component({
  selector: '[form-field-file]',
  template: `
    <label [formGroup]="formGroup" [for]="inputId"
           [tabIndex]="item.tabindex">
      <input type="file"
             [id]="inputId"
             [formControlName]="formName"
             (keyup)="onKey($event)"
             [attr.aria-label]="item.content || null"
             [required]="required"
             [attr.accept]="item.settings.inputSettings?.accept"
             [attr.multiple]="item.settings.inputSettings?.multiple"
             (change)="dataChanged($event)" style="display: none">

      @for (child of item.children; track child.uId) {
        <div
          [appClickableBlock]="child"
          [class]="child.uId"
          [item]="child"
          app-block
          [disableTabIndex]="true"
        ></div>
      }
      <mat-error *ngIf="invalid">{{ getErrorMessage$() | async | translate }}</mat-error>
    </label>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FormFieldFileComponent extends FormFieldBase {
  get inputId() {
    return `${this.item.uId}-input_${this.formName}`;
  }
}
